var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", [
    _c(
      "div",
      { staticClass: "lead-panel" },
      [
        _c("label", { attrs: { for: `toggle-opportunity-${_vm.pkg.id}` } }, [
          _vm._v("\n      " + _vm._s(_vm.pkg.name) + "\n    "),
        ]),
        _vm._v(" "),
        _c("toggle-button", {
          attrs: {
            id: `toggle-opportunity-${_vm.pkg.id}`,
            sync: true,
            labels: { checked: "Yes", unchecked: "No" },
            color: { checked: _vm.$brandPrimary, unchecked: "#b7b7b7" },
          },
          model: {
            value: _vm.pkg.opted_in,
            callback: function ($$v) {
              _vm.$set(_vm.pkg, "opted_in", $$v)
            },
            expression: "pkg.opted_in",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticStyle: { padding: "1em" } }, [
      _vm.pkg.opted_in && _vm.pkg.package_options.length > 1
        ? _c(
            "div",
            [
              _vm._v("\n      Select package options\n      "),
              _vm._l(_vm.pkg.package_options, function (option, index) {
                return _c("profile-talent-packages-list-item-option", {
                  key: option.id,
                  staticClass: "packages-list-item",
                  attrs: {
                    option: option,
                    validation: _vm.validation.package_options.$each[index],
                    user: _vm.user,
                  },
                })
              }),
            ],
            2
          )
        : _vm.pkg.opted_in && _vm.pkg.package_options.length === 1
        ? _c(
            "div",
            [
              _c("profile-talent-packages-list-item-single-option", {
                attrs: {
                  pkg: _vm.pkg,
                  validation: _vm.validation.package_options.$each[0],
                  user: _vm.user,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.validation.mustSelectPackageOption
        ? _c("div", { staticClass: "help-block" }, [
            _vm._v("You must select at least one package option\n    "),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }